import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import Img from 'react-image'

class VideoCardItem extends Component {

    render(){

        const {src, title, link, width} = this.props
        return (
            <div className={`col-${width} entertainment-card-item`}>
                <Link to={link}>
                    <Img src={src} alt={title}/>
                </Link>
            </div>
        )
    }
}
VideoCardItem.propType = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
}

export default VideoCardItem


// WEBPACK FOOTER //
// ./src/components/video-card.js